import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    rowContainer: {
        justifyContent: "space-between",
        alignItems: "center",
        flexDirection: "row",
        flexWrap: "wrap",
        width: "100%"
    },
    switchesContainer: {
        justifyContent: "space-between",
        alignItems: "center",
        flexDirection: "row",
        flexWrap: "wrap",
        width: "100%"
    },
    previewContainer: {
        justifyContent: "center",
        alignItems: "center",
        minHeight: 120
    },
    title: {
        marginBottom: 20
    },
    descText: {
        marginBottom: 20
    },
    contentContainer: {
        width: "100%",
        padding: 20
    },
    scrollContent: {
        flexGrow: 1
    },
    container: {
        flex: 1
    }
});
export default stylesheet;
